'use client'
import classnames from 'classnames'
import {LazyLoadComponent} from 'react-lazy-load-image-component'
import AnimatedArrow from './_images/animated-arrow-currentColor.svg'
import {externalLinks} from '~/routing/external-links'
import styles from './styles.module.css'
import HoverTrackingDiv from '~/mercuryWebCompat/_components/UtilityDivs/HoverTrackingDiv'

export default function DemoCard() {
  return (
    <div className={styles.absoluteWrapper}>
      <HoverTrackingDiv className={styles.cardWrapper}>
        {hovered => (
          <a href={externalLinks.demo} className={classnames(styles.card)}>
            <LazyLoadComponent>
              <div
                className={classnames(
                  styles.videoWrapper,
                  !hovered && styles.inactive
                )}
              >
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  poster="/icons/Home/demo-poster.png"
                >
                  <source src="/videos/Home/demo-card.webm" type="video/webm" />
                  <source src="/videos/Home/demo-card.mp4" type="video/mp4" />
                </video>
              </div>
              <div className={styles.cardContents}>
                <p>Explore Demo</p>
                <AnimatedArrow
                  className={classnames(styles.icon, hovered && styles.rotate)}
                />
              </div>
            </LazyLoadComponent>
          </a>
        )}
      </HoverTrackingDiv>
    </div>
  )
}
